import {IController, IFormController, IModule} from "angular";
import {Debugger} from "debug";
import {MøtemalSkjemaModell} from "../../MalmøteTjeneste";

const debug: Debugger = require('debug')('MøtemalDetaljerSkjemaKontroller');
const css = require('./møtemalDetaljerSkjema.scss');

export class MøtemalDetaljerSkjemaKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular.component('wmMoetemalDetaljerSkjema', {
            bindings: {
                moetemalModell: '<',
                skjema: '<'
            },
            controller: MøtemalDetaljerSkjemaKontroller.forInjisering(),
            template: require('./møtemalDetaljerSkjema.html')
        });
    }

    static forInjisering() {
        return [
            MøtemalDetaljerSkjemaKontroller
        ]
    }

    constructor() {
    }

    moetemalModell: MøtemalSkjemaModell; //settes via bindings
    skjema: IFormController; //settes via bindings

    varighetEndret(varighet: number) {
        this.moetemalModell.beregnSluttdato();
    }

    //hjelpemetoder

}
